import { modifier } from 'ember-modifier';

export default modifier((element: HTMLElement, [key, action]: [string, (event: KeyboardEvent) => void]) => {
  const keydownHandler = (event: KeyboardEvent): void => {
    if (event.key !== key) return;
    action(event);
  };

  element.addEventListener('keydown', keydownHandler);
  return () => {
    element.removeEventListener('keydown', keydownHandler);
  };
});
